var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4",staticStyle:{"font-family":"OpenSans, sans-serif"}},[_c('h1',{staticClass:"pb-4"},[_vm._v("Access Token")]),_c('p',{staticClass:"token"},[_vm._v(_vm._s(_vm.token))])])}
var staticRenderFns = []

export { render, staticRenderFns }